import { ContactProcedures } from './contact-procedures';
import { ContactProducts } from './contact-products';

export function ContactInterests({ contactId }: { contactId: string }) {
  return (
    <div className="space-y-4">
      <ContactProcedures contactId={contactId} />

      <ContactProducts contactId={contactId} />
    </div>
  );
}
